import { Nav, Navbar } from "react-bootstrap";
import NavbarVerticalMenu from "./NavbarVerticalMenu";
import {
  UilArrowFromRight,
  UilLeftArrowToLeft,
} from "@iconscout/react-unicons";
import { useAppContext } from "providers/AppProvider";
import Button from "components/base/Button";
import NavbarVerticalCollapseProvider from "./NavbarVerticalCollapseProvider";
import { useEffect, useState } from "react";
import axiosInstance from "helpers/api";
import SidebarSkeleton from "components/skeletons/SidebarSkeleton";
import "./navbar-ai-theme.css";

const NavbarVertical = () => {
  const {
    config: {
      openNavbarVertical,
      navbarVerticalAppearance,
      isNavbarVerticalCollapsed,
    },
    setConfig,
  } = useAppContext();

  const [filterRoute, setFilterRoute] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const getRoutes = async () => {
      setIsLoading(true);
      try {
        const response = await axiosInstance.get("/navbar");
        setFilterRoute(response.data.data.userNavItems);
      } catch (error: any) {
        console.error(
          "Error fetching routes:",
          error.response?.data || error.message
        );
      } finally {
        setIsLoading(false);
      }
    };

    getRoutes();
  }, []);

  return (
    <NavbarVerticalCollapseProvider>
      <Navbar
        className="navbar-vertical"
        expand="lg"
        variant=""
        data-navbar-appearance={
          navbarVerticalAppearance === "darker" ? "darker" : ""
        }
      >
        <Navbar.Collapse id="navbarVerticalCollapse" in={openNavbarVertical}>
          <div className="navbar-vertical-content">
            <Nav className="flex-column" as="ul" id="navbarVerticalNav">
              {isLoading ? (
                <SidebarSkeleton itemCount={10} />
              ) : (
                <Nav.Item>
                  <NavbarVerticalMenu level={1} routes={filterRoute} />
                </Nav.Item>
              )}
            </Nav>
          </div>
        </Navbar.Collapse>
        <div className="navbar-vertical-footer">
          <Button
            className="navbar-vertical-toggle border-0 fw-semibold w-100 white-space-nowrap d-flex align-items-center"
            onClick={() => {
              setConfig({
                isNavbarVerticalCollapsed: !isNavbarVerticalCollapsed,
              });
            }}
          >
            {isNavbarVerticalCollapsed ? (
              <UilArrowFromRight size={16} className="mb-1" />
            ) : (
              <>
                <UilLeftArrowToLeft size={16} className="mb-1" />
                <span className="ms-2">Collapsed View</span>
              </>
            )}
          </Button>
        </div>
      </Navbar>
    </NavbarVerticalCollapseProvider>
  );
};

export default NavbarVertical;
